import { Link } from 'react-router-dom';
import { sign_out, type AdminProfile } from '../auth';

export default function Nav({
  admin,
  on_signed_out,
}: {
  admin: AdminProfile;
  on_signed_out: () => void;
}) {
  async function handle_sign_out() {
    await sign_out();
    on_signed_out();
  }

  return (
    <nav style={{ borderBottom: '1px solid var(--line)', background: 'var(--bg)' }}>
      <div
        className="container"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          paddingTop: 16,
          paddingBottom: 16,
        }}
      >
        <div style={{ display: 'flex', gap: 24, alignItems: 'center' }}>
          <Link
            to="/"
            style={{ display: 'flex', alignItems: 'center', gap: 8, color: 'inherit' }}
          >
            <img
              src="/img/captomi-logo-2.png"
              alt=""
              style={{ height: 28 }}
              onError={(e) => ((e.target as HTMLImageElement).style.display = 'none')}
            />
            <strong style={{ color: 'var(--green-900)' }}>Captomi Admin</strong>
          </Link>
          <Link to="/" className="muted">
            Home
          </Link>
          <Link to="/tenants" className="muted">
            Tenants
          </Link>
          <Link to="/bookings" className="muted">
            Bookings
          </Link>
          <Link to="/usage" className="muted">
            Usage
          </Link>
          <Link to="/business360" className="muted">
            Business 360
          </Link>
          <Link to="/seed" className="muted">
            Seed
          </Link>
          <Link to="/apps" className="muted">
            Apps
          </Link>
          <Link to="/admins" className="muted">
            Admins
          </Link>
          <Link to="/audit" className="muted">
            Audit
          </Link>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <span className="muted" style={{ fontSize: 13 }}>
            {admin.email}
          </span>
          <button className="secondary" onClick={handle_sign_out}>
            Sign out
          </button>
        </div>
      </div>
    </nav>
  );
}
